import { parseISO } from 'date-fns';
import ReactDOMServer from 'react-dom/server';
import { TimeElement } from '../../TimeElement/TimeElement';
import { capitalizeFirstLetter } from '../../Util';
import formatCloseRelative from '../../Util/formatCloseRelative';
import { type TravelTimeV2Status } from '../Sources/TravelTimeV2StatusSource';

function trafficStatusText(status: string) {
    switch (status) {
        case 'freeflow':
            return 'Normal framkomlighet';
        case 'heavy':
            return 'Långsam trafik';
        case 'congested':
            return 'Mycket långsam trafik';
        case 'impossible':
            return 'Stillastående trafik';
        default:
            return 'Aktuell data saknas';
    }
}

function getSpeed(speed: number | undefined) {
    if (speed === undefined || speed === null || speed === 0) {
        return '';
    }

    return `(${speed} km/tim)`;
}
export default function TravelTimeV2(properties: TravelTimeV2Status): string {
    // Do not show a tooltip for segments with no status. Returning an
    // empty string signals RoadStatusLayer to unbind the tooltip for green segments.
    if (!properties.status) {
        return '';
    }

    return ReactDOMServer.renderToStaticMarkup(
        <div className="tooltip">
            <p>
                {trafficStatusText(properties.status)} {getSpeed(properties.speed)}
            </p>

            <dl className="tooltip-details">
                <dt>Uppdaterad:</dt>
                <dd>
                    {properties.updateDate && (
                        <TimeElement date={parseISO(properties.updateDate)}>
                            {capitalizeFirstLetter(formatCloseRelative(parseISO(properties.updateDate)))}
                        </TimeElement>
                    )}
                </dd>
            </dl>
        </div>,
    );
}
